import { combineReducers } from "redux";
import {
  CHANGE_PROFESSION_WEIGHT_REQUEST,
  CREATE_PROFESSION_REQUEST,
  FETCH_PROFESSIONS_REQUEST,
  UPDATE_PROFESSION_REQUEST,
} from "./constants";
import { CREATE_DOCTOR_PROFESSION_REQUEST } from "../doctor/constants";
import { Action } from "./types";
import { Action as DoctorAction } from "../doctor/types";
import { Profession } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";

function items(state: Profession[] = [], action: Action): Profession[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_PROFESSIONS_REQUEST):
      return action.payload;

    case UPDATE_PROFESSION_REQUEST:
    case CHANGE_PROFESSION_WEIGHT_REQUEST:
      return state.map((prof) =>
        prof.id === action.data.professionId ? { ...prof, isFetching: true } : prof
      );

    case getSuccessActionType(UPDATE_PROFESSION_REQUEST):
    case getSuccessActionType(CHANGE_PROFESSION_WEIGHT_REQUEST):
      return state.map((prof) =>
        prof.id === action.data.professionId ? { ...action.payload, isFetching: false } : prof
      );

    case getFailureActionType(UPDATE_PROFESSION_REQUEST):
    case getFailureActionType(CHANGE_PROFESSION_WEIGHT_REQUEST):
      return state.map((prof) =>
        prof.id === action.data.professionId ? { ...prof, isFetching: false } : prof
      );

    case getSuccessActionType(CREATE_PROFESSION_REQUEST):
      return [...state, action.payload];
    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action | DoctorAction): boolean {
  switch (action.type) {
    case FETCH_PROFESSIONS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_PROFESSIONS_REQUEST):
    case getFailureActionType(FETCH_PROFESSIONS_REQUEST):
      return false;

    case CREATE_PROFESSION_REQUEST:
      return true;
    case getSuccessActionType(CREATE_PROFESSION_REQUEST):
    case getFailureActionType(CREATE_PROFESSION_REQUEST):
      return false;

    case CREATE_DOCTOR_PROFESSION_REQUEST:
      return true;
    case getSuccessActionType(CREATE_DOCTOR_PROFESSION_REQUEST):
    case getFailureActionType(CREATE_DOCTOR_PROFESSION_REQUEST):
      return false;

    default:
      return state;
  }
}

export const professions = combineReducers({ items, isFetching });
